import zip from '@/js/forms/zip'
import formsSelect from '@/js/forms/select.js'
import formsInputDate from "@/js/forms/inputDate.js";
import halfwidth from '@/js/forms/halfwidth.js'

const forms = () => {
    zip();
    formsSelect()
    formsInputDate()
    halfwidth()
}

export default forms;
